import { render, staticRenderFns } from "./SummarySaleTargetAmountTable.vue?vue&type=template&id=36e4db1f&scoped=true"
import script from "./SummarySaleTargetAmountTable.vue?vue&type=script&lang=js"
export * from "./SummarySaleTargetAmountTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e4db1f",
  null
  
)

export default component.exports